import { storyblokEditable, StoryblokComponent } from "@storyblok/react";

const PortalCardRow = ({ blok }) => {
  return (
    <section {...storyblokEditable(blok)} className="w-full py-12">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-stretch">
          {blok.cards?.map((nestedBlok) => (
            <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default PortalCardRow;
